// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/contact-card/contact-card.component.scss
// module id = 298
// module chunks = 0